import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedConversation: null,
};

const conversationsSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setSelectedConversation(state, action) {
      state.selectedConversation = action.payload;
    },
  },
});

export const { setSelectedConversation } =
  conversationsSlice.actions;

export default conversationsSlice.reducer;

export const selectSelectedConversation = (state) =>
  state.conversation.selectedConversation;
